import "regenerator-runtime/runtime";
import _asyncToGenerator from "/bitrise/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { Notification, MessageBox } from 'element-ui';
import '@/styles/message_box.css';
import { notificationStatus } from '@/utils/enums';
import moment from 'moment';
export function notification_message(title, message, type) {
  if (type === notificationStatus.ERROR) {
    return Notification.error({
      title: title,
      message: message,
      duration: 10000,
      showClose: true
    });
  } else {
    return Notification({
      title: title,
      message: message,
      type: type,
      duration: 5000,
      showClose: true
    });
  }
}
/* customClassがmessage_defaultの場合は完了ボタンの色を戻る、customClassがmessage_deleteの場合は削除ボタンの色を戻る*/

export function message_box_confirm(_x, _x2, _x3, _x4) {
  return _message_box_confirm.apply(this, arguments);
}

function _message_box_confirm() {
  _message_box_confirm = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(title, message, yesText, customClass) {
    var result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return MessageBox.confirm(message, title, {
              confirmButtonText: yesText,
              cancelButtonText: 'いいえ',
              showClose: false,
              customClass: customClass,
              center: true
            }).catch(function () {
              return false;
            });

          case 2:
            result = _context.sent;

            if (!result) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", true);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _message_box_confirm.apply(this, arguments);
}

export function message_box_alert(_x5, _x6) {
  return _message_box_alert.apply(this, arguments);
}

function _message_box_alert() {
  _message_box_alert = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(message, customClass) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return MessageBox.alert(message, '', {
              confirmButtonText: 'OK',
              showClose: false,
              showCancelButton: false,
              title: null,
              customClass: customClass,
              center: true
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _message_box_alert.apply(this, arguments);
}

export function commentTime(value) {
  var date = moment(String(value)).format('YYYY年MM月DD日');
  var dateNow = moment(String(new Date())).format('YYYY年MM月DD日');
  var time = moment(String(value)).format('HH:mm');

  if (date === dateNow) {
    return time;
  }

  return moment(String(value)).format('YYYY年MM月DD日 HH:mm');
}